import truncate from 'truncate';
import config from '@/config';

export function facebookPopup (data) {
    var popupUrl = "https://www.facebook.com/dialog/share"
        + "?app_id=" + config.facebookAppId
        + "&href=" + encodeURIComponent(data.url)
        + "&display=popup";

    return window.open(
        popupUrl,
        'FacebookShare',
        'width=575,height=690'
    );
};

export function twitterPopup (data) {
    if (data.text) {
        data.text = truncate(data.text, 278, {
            ellipsis: '…'
        });
    }

    var popupUrl = "https://twitter.com/intent/tweet"
        + "?url=" + encodeURIComponent(data.url)
        + "&text=" + encodeURIComponent(data.text);
        // + "&via=" + encodeURIComponent(via);

    return window.open(
        popupUrl,
        'TwitterShare',
        'width=500,height=250'
    );
};

export function copy (text) {
    var node = document.createTextNode(text),
        selection = window.getSelection(),
        range = document.createRange(),
        isSuccessful = null;

    document.body.appendChild(node);
    selection.removeAllRanges();
    range.selectNodeContents(node);
    selection.addRange(range);
    isSuccessful = document.execCommand("copy");

    selection.removeAllRanges();
    document.body.removeChild(node);

    return isSuccessful;
};